export interface PresencePresentationSource {
  username?: string
  activity?: string
  current_table?: string | null
}

export type PresenceTone = 'available' | 'playing' | 'unavailable' | 'offline'

export interface PresencePresentation {
  tone: PresenceTone
  label: string
}

export function presentPresence(
  user: PresencePresentationSource | null | undefined,
  tableName?: string,
): PresencePresentation {
  if (!user) return { tone: 'offline', label: 'Offline' }
  if (user.activity === 'available') return { tone: 'available', label: 'Available' }
  if (user.activity === 'table') {
    return { tone: 'playing', label: tableName ? `At ${tableName}` : 'At a table' }
  }
  if (user.activity === 'armies') return { tone: 'unavailable', label: 'Cooking fan army' }
  if (user.activity === 'footer') return { tone: 'unavailable', label: 'Lost in footer' }
  if (user.activity === 'admin') return { tone: 'unavailable', label: 'Maintenance work' }
  return { tone: 'unavailable', label: 'Unavailable' }
}
